export enum ASSETS_SORTS {}

export enum ASSETS_FILTERS {
  CONTEXT = "context[organization]",
  LOCATION_ID = "filter[location_id]",
  ASSET_ID = "filter[asset_id]",
}

export enum ASSETS_METADATA {
  STATISTICS = "statistics",
}
